import React, { Component } from "react";
import AppTable from "../../partials/AppTable";
import CategoryModal from "./CategoryModal";
import CategoryEditModal from "./CategoryEditModal";
import LayoutWrapper from "./LayoutWrapper";
import CategorySearch from "./CategorySearch";

export class Category extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("Category");

    this.state = {
      tableData: [],
      rowcount: 0,
      loader: false,
      columns: [
        {
          dataIndex: "name",
          title: "Category Name",
        },
        {
          dataIndex: "attachment_id",
          title: "Logo",
          render: (text, record) => {
            const fileId = record.attachment_id || record.logo;
            if (fileId) {
              const authToken = window.store?.getState()?.root?.auth || "";
              const url = window.app.api
                .request(window.app.apis().fileDownloader)
                .urltransform({ attachmentId: fileId }).url + "?auth=" + authToken;

              return (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#ff9800', textDecoration: 'underline' }}
                  onClick={() => {
                    if (window.success) window.success("File downloaded successfully");
                  }}
                >
                  logo
                </a>
              );
            }
            return "N/A";
          },
        },
        {
          dataIndex: "description",
          title: "Description",
          render: (text) => text && text.length > 50 ? text.substring(0, 50) + "..." : text,
        },
        {
          dataIndex: "created_on",
          title: "Created On",
          render: (text, record) => record.createdAt ? new Date(record.createdAt).toLocaleDateString('en-GB').replace(/\//g, '-') : "12-09-2022",
        },
        {
          dataIndex: "action",
          title: "Action",
          sorter: false,
          render: (text, record) => {
            return (
              <div className="dropdown dropdown-action text-end">
                <a href="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="material-icons" style={{ color: '#888' }}>more_vert</i>
                </a>
                <div className="dropdown-menu dropdown-menu-right" style={{ minWidth: '150px', padding: '10px', borderRadius: '8px' }}>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ color: '#f39c12', fontSize: '14px', padding: '5px 10px' }}
                    onClick={(e) => { e.preventDefault(); this.editAction(record); }}
                  >
                    <i className="la la-pencil m-r-5" style={{ fontSize: '16px' }}></i> View/Edit category
                  </a>
                </div>
              </div>
            );
          }
        }
      ],
      search: {
        page: 1,
        limit: 10,
        name: "",
        createdAt: "",
      },
      editData: {},
      viewMode: false,
      editMode: false,
      modalKey: null,
    };
  }

  componentDidMount() {
    this.fetchList();
  }

  fetchList = () => {
    this.setState({ loader: true });
    let payload = { ...this.state.search };
    // Remove empty strings
    payload = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v !== ""));

    if (this.props.api && this.props.api.apiGetMasterCategory) {
      this.props.api
        .apiGetMasterCategory(payload)
        .then((res) => {
          let responseData = res.data?.records || res.lists || res.data;
          let data = Array.isArray(responseData) ? responseData : [];
          let total = res.data?.totalCount || res.total || res.count || data.length;
          this.setState({
            tableData: data,
            rowcount: total,
            loader: false,
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loader: false });
        });
    } else {
      this.setState({ loader: false });
    }
  };

  onPageChange = (pageData) => {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || 10,
        },
      },
      () => this.fetchList()
    );
  };

  onSearchChange = (data) => {
    let newSearch = {
      page: 1,
      limit: this.state.search.limit || 10,
      name: "",
      createdAt: "",
      ...data,
    };
    if (newSearch.created_on) {
      newSearch.createdAt = newSearch.created_on;
      delete newSearch.created_on;
    }
    delete newSearch.category_id;
    delete newSearch.id;
    this.setState(
      {
        search: newSearch,
      },
      () => this.fetchList()
    );
  };

  openAddModal = () => {
    this.setState({ editMode: false, viewMode: false, editData: null, modalKey: Date.now() });
  };

  editAction = (record) => {
    if (!record) return;
    this.setState({ loader: true });

    if (this.props.api && this.props.api.apiGetMasterCategoryById) {
      this.props.api.apiGetMasterCategoryById({ category_id: record._id || record.id })
        .then(res => {
          if (res && res.data) {
            let editData = { ...(res.data.data || res.data) };
            let fileId = editData.attachment_id || editData.logo;
            
            const openModal = () => {
              this.setState({
                editMode: true,
                viewMode: false,
                editData: editData,
                modalKey: Date.now(),
                loader: false
              }, () => {
                document.querySelector("#category_edit_modal_trigger")?.click();
              });
            };

            if (fileId && this.props.api.apiGetFileMetaData) {
              this.props.api.apiGetFileMetaData({ attachment_id: fileId })
                .then(metaRes => {
                  let metaData = metaRes?.file_name ? metaRes : (metaRes?.data?.data || metaRes?.data);
                  if (metaData && metaData.file_name) {
                    editData.file_name = metaData.file_name;
                  }
                  openModal();
                })
                .catch(err => {
                  console.error(err);
                  openModal();
                });
            } else {
              openModal();
            }
          }
        })
        .catch(err => {
          console.error(err);
          this.setState({ loader: false });
          if (window.error) window.error("Failed to fetch category details");
        });
    } else {
      this.setState({
        editMode: true,
        viewMode: false,
        editData: record,
        modalKey: Date.now(),
        loader: false
      }, () => {
        document.querySelector("#category_edit_modal_trigger")?.click();
      });
    }
  };

  viewAction = (record) => {
    if (!record) return;
    this.setState({ loader: true });

    if (this.props.api && this.props.api.apiGetMasterCategoryById) {
      this.props.api.apiGetMasterCategoryById({ category_id: record._id || record.id })
        .then(res => {
          if (res && res.data) {
            let editData = { ...(res.data.data || res.data) };
            let fileId = editData.attachment_id || editData.logo;
            
            const openModal = () => {
              this.setState({
                editMode: false,
                viewMode: true,
                editData: editData,
                modalKey: Date.now(),
                loader: false
              }, () => {
                document.querySelector("#category_edit_modal_trigger")?.click();
              });
            };

            if (fileId && this.props.api.apiGetFileMetaData) {
              this.props.api.apiGetFileMetaData({ attachment_id: fileId })
                .then(metaRes => {
                  let metaData = metaRes?.file_name ? metaRes : (metaRes?.data?.data || metaRes?.data);
                  if (metaData && metaData.file_name) {
                    editData.file_name = metaData.file_name;
                  }
                  openModal();
                })
                .catch(err => {
                  console.error(err);
                  openModal();
                });
            } else {
              openModal();
            }
          }
        })
        .catch(err => {
          console.error(err);
          this.setState({ loader: false });
          if (window.error) window.error("Failed to fetch category details");
        });
    } else {
      this.setState({
        editMode: false,
        viewMode: true,
        editData: record,
        modalKey: Date.now(),
        loader: false
      }, () => {
        document.querySelector("#category_edit_modal_trigger")?.click();
      });
    }
  };

  deleteAction = (record) => {
    if (!record) return;
    window.confirm("Are you sure you want to delete this category?").promise.then(() => {
      this.setState({ loader: true });
      const category_id = record.category_id || record._id || record.id;
      this.props.api
        .apiDeleteMasterCategory({}, { category_id })
        .then(() => {
          window.success("Category deleted successfully");
          this.fetchList();
          this.searchRef?.getCategories && this.searchRef.getCategories();
        })
        .catch(() => {
          window.error("Failed to delete category");
          this.setState({ loader: false });
        });
    });
  };

  handleModalSubmit = (e, formData) => {
    e.preventDefault();
    let { editMode, editData } = this.state;

    // Manual validation
    if (!formData.name || !formData.name.trim()) {
      if (window.error) window.error("Please enter a valid Category Name");
      return;
    }

    if (!editMode && !formData.logo) {
      if (window.error) window.error("Please upload a Logo");
      return;
    }

    if (!formData.description || !formData.description.trim()) {
      if (window.error) window.error("Please enter a Description");
      return;
    }

    this.setState({ loader: true });

    let payload = new FormData();
    if (formData.name) payload.append('name', formData.name);
    if (formData.description) payload.append('description', formData.description);
    if (formData.logo && formData.logo instanceof File) {
      payload.append('file', formData.logo);
    }

    if (editMode && editData) {
      const category_id = editData.category_id || editData._id || editData.id;
      this.props.api
        .apiUpdateMasterCategory(payload, { category_id })
        .then(() => {
          window.success("Category updated successfully");
          this.setState({ modalKey: Date.now() });
          document.querySelector("#category_edit_modal #bsmodalclose")?.click();
          this.fetchList();
          this.searchRef?.getCategories && this.searchRef.getCategories();
        })
        .catch((err) => {
          let errorMsg = err?.response?.data?.message || err?.response?.data?.issues?.message || "Failed to update category";
          window.error(errorMsg);
          this.setState({ loader: false });
        });
    } else {
      this.props.api
        .apiCreateMasterCategory(payload)
        .then(() => {
          window.success("Category added successfully");
          this.setState({ modalKey: Date.now() });
          document.querySelector("#category_modal #bsmodalclose")?.click();
          this.fetchList();
          this.searchRef?.getCategories && this.searchRef.getCategories();
        })
        .catch((err) => {
          let errorMsg = err?.response?.data?.message || err?.response?.data?.issues?.message || "Failed to add category";
          window.error(errorMsg);
          this.setState({ loader: false });
        });
    }
  };

  render() {
    let { tableData, rowcount, loader, columns, editData, viewMode, editMode, search } = this.state;

    const headerRight = (
      <button
        className="btn btn-warning text-white fw-bold rounded-pill px-4"
        data-bs-toggle="modal"
        data-bs-target="#category_modal"
        onClick={this.openAddModal}
        style={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}
      >
        <i className="fa fa-plus me-1"></i> Add
      </button>
    );

    return (
      <LayoutWrapper title="Assessment Category" back="" headerRight={headerRight}>

        <div className="row">
          <div className="col-12">
            <CategorySearch ref={(r) => this.searchRef = r} onSearch={this.onSearchChange} api={this.props.api} />
            <div className="card bg-white p-3">
              <AppTable
                data={tableData}
                columns={columns}
                total={rowcount}
                loading={loader}
                onChange={(...arg) => this.onPageChange(...arg)}
                isCustomRowKey={true}
                customRowKey="_id"
                reorder={true}
                viewable={false}
                editable={false}
                deletable={false}
                targetType="modal"
                editTarget="#category_edit_modal"
                viewTarget="#category_edit_modal"
                editAction={this.editAction}
                viewAction={this.viewAction}
                deleteAction={this.deleteAction}
                isresponsive={true}
              />
            </div>
          </div>
        </div>

        <CategoryModal
          id="category_modal"
          modalKey={this.state.modalKey}
          title="Add Category"
          submitText="Save"
          onSubmit={this.handleModalSubmit}
          api={this.props.api}
          onClose={() => this.setState({ editData: null, editMode: false, viewMode: false, modalKey: Date.now() })}
        />

        <button
          id="category_edit_modal_trigger"
          className="d-none"
          data-bs-toggle="modal"
          data-bs-target="#category_edit_modal"
        ></button>

        <CategoryEditModal
          id="category_edit_modal"
          modalKey={this.state.modalKey}
          title={viewMode ? "View category" : "Edit category"}
          submitText="Update"
          editdata={editData}
          editMode={editMode}
          viewMode={viewMode}
          onSubmit={this.handleModalSubmit}
          api={this.props.api}
          onClose={() => this.setState({ editData: null, editMode: false, viewMode: false, modalKey: Date.now() })}
        />
      </LayoutWrapper>
    );
  }
}

export default connect(Category);
